import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGoogleLogin } from '@react-oauth/google';
import { ErrorToastContainer } from '../function/CustomFunction';
import { useNavigate } from 'react-router-dom';


export default function Singup({setloder}) {
  const navigate = useNavigate();
  const sing_up = useGoogleLogin({
    onSuccess: tokenResponse => {
      setloder(true);
      fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenResponse.access_token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setloder(false);
          let newdata = {'email' : data.email,'name': data.name}
          navigate(`/register/${btoa(btoa(btoa(JSON.stringify(newdata))))}`);
        });
    },
    onError: (e)=>{
      setloder(false);
      ErrorToastContainer("Internal Server Problem")
    }
  });
  return (
    <button
      type="button"
      onClick={() => sing_up()}
      style={{
        width: '100%',
        height: 42,
        border: 'none',
        borderRadius: 10,
        background: '#2d4278',
        color: '#fff',
        fontSize: 12,
        fontWeight: 700,
        cursor: 'pointer',
        letterSpacing: 0.3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        transition: 'transform 0.15s, box-shadow 0.15s',
        boxShadow: '0 4px 14px rgba(45,66,120,0.3)',
      }}
      onMouseOver={e => {
        e.currentTarget.style.transform = 'translateY(-1px)';
        e.currentTarget.style.boxShadow = '0 6px 18px rgba(45,66,120,0.4)';
      }}
      onMouseOut={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 14px rgba(45,66,120,0.3)';
      }}
    >
      <FontAwesomeIcon icon={faGoogle} />
      Register With Google
    </button>
  )
}



